import React from 'react'

const EditStock = () => {
    return (
        <div>

        </div>
    )
}

export default EditStock
